import { render, staticRenderFns } from "./InsLayer.vue?vue&type=template&id=2caf9de5&scoped=true"
import script from "./InsLayer.vue?vue&type=script&lang=ts"
export * from "./InsLayer.vue?vue&type=script&lang=ts"
import style0 from "./InsLayer.vue?vue&type=style&index=0&id=2caf9de5&prod&lang=less"
import style1 from "./InsLayer.vue?vue&type=style&index=1&id=2caf9de5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caf9de5",
  null
  
)

export default component.exports